import $ from "jquery";
import * as _ from "underscore";

import * as accountModal from "accountModal";
import * as genericModals from "genericModals";
import * as localAPI from "localAPI";
import * as modalDialog from "modalDialog";
import models from "models/models";
import * as mustcache from "mustcache";
import readlangClient from "readlangClient";
import * as bookUtils from "shared/bookUtils";
import * as languageMap from "shared/languageMap";
import * as sharedConfig from "shared/sharedConfig";
import * as signupModal from "signupModal";
import LanguageSelectView from "views/LanguageSelectView";
import * as walkthrough from "walkthrough";
import XRegExp from "xregexp";

let containerElement;
let renderedCallback;
let appRouter;
let pageName = "uploadPage";
let inputTextArea;
let initialized = false;
let totalSecondsAudioUploaded;

export const name = pageName;

export const render = async (
  _containerElement,
  _renderedCallback,
  _appRouter
) => {
  containerElement = _containerElement;
  renderedCallback = _renderedCallback;
  appRouter = _appRouter;

  let ready;
  let ePub;

  if (!initialized) {
    models.user.on("change:currentLearningLanguage", () => {
      if ($("body").attr("id") === pageName) {
        containerElement
          .find(".language")
          .text(
            languageMap.map[models.user.get("currentLearningLanguage")].english
          );
      }
    });
    initialized = true;
  }

  const data: any = {
    localMode: await localAPI.isLocalMode(),
    categories: bookUtils.categories,
  };

  if (models.user.hasPremiumAccess()) {
    const { totalSeconds } = (
      await readlangClient.request("GET", "/api/audioUsage", {})
    ).data;
    totalSecondsAudioUploaded = totalSeconds;

    /** Maximum number of seconds of audio you're allowed to upload */
    const limit = models.user.hasPremiumPlusAccess()
      ? sharedConfig.audioUploadLimitPremiumPlus
      : sharedConfig.audioUploadLimitPremium;

    if (totalSeconds > 0) {
      data.audioUploadedSize = () => {
        const hours = Math.floor(totalSeconds / 3600);
        let timeLeft = totalSeconds - hours * 3600;

        const minutes = Math.floor(timeLeft / 60);
        timeLeft = Math.floor(timeLeft - minutes * 60);

        return `${hours ? `${hours} hour${hours === 1 ? "" : "s"} ` : ""}${minutes ? `${minutes} minute${minutes === 1 ? "" : "s"} ` : ""} ${hours === 0 ? `${timeLeft} seconds` : ""}`;
      };
      data.audioUploadedPercentage = Math.round((100 * totalSeconds) / limit);
      data.audioUploadedLimit = `${Math.floor(limit / 3600)} hours`;
      data.audioUploadedOverLimit = data.audioUploadedSize > limit;
    }

    data.showAudioPlusUpsell = !models.user.hasPremiumPlusAccess();
    data.plusLimit = `${sharedConfig.audioUploadLimitPremiumPlus / 3600} hours`;
  }

  containerElement.html(mustcache.render("uploadPage", data));
  inputTextArea = containerElement.find(".plainTextInput");
  inputTextArea.focus();

  $(".audioPlusUpsell").click(() => {
    appRouter.navigate("/account", { trigger: true });
  });

  if (await localAPI.isLocalMode()) {
    containerElement.find('.addDocumentForm [name="public"]').click((event) => {
      event.stopPropagation();
      event.preventDefault();

      signupModal.show({
        headingHtml: "<h2>Sign in to share texts</h2>",
        models: models,
      });
    });
  }

  const fileUploadInput = containerElement.find(".upload");

  // XXX Manage subviews?
  new LanguageSelectView({
    learningLanguages: true,
    el: containerElement.find(".languageSelector"),
    model: models.user,
    field: "currentLearningLanguage",
    hint: "Set the language of this document",
    onChange: function () {
      //updateRedditButton();
    },
    english: true,
  });

  containerElement.find('[data-clickable="signUpButton"]').click((event) => {
    event.preventDefault();
    event.stopPropagation();

    signupModal.show({
      headingHtml: "<h2>Sign in to import ePub books</h2>",
      models: models,
    });
  });

  const characterBeforeNewLine = new XRegExp("\\p{L}.*\\n");
  const containsCharacter = new XRegExp("\\p{L}");

  let titleManuallyEdited = false;

  const onTextInput = () => {
    const textInput = inputTextArea.val();

    if (
      (!ready && characterBeforeNewLine.test(textInput)) ||
      textInput.length > 3
    ) {
      ready = true;
      containerElement.find(".addDocumentForm .whenReady").fadeIn();
      containerElement.find(".hideWhenReady").hide();
      containerElement.find(".addDocumentForm .uploadPlainText").fadeIn();
      containerElement
        .find(".addDocumentForm .right")
        .attr("disabled", "disabled");
      const lines = textInput.split("\n");

      if (!titleManuallyEdited) {
        _.every(lines, (line) => {
          if (containsCharacter.test(line)) {
            $('.addDocumentForm [name="title"]').val(line);
            return false;
          }
        });
      }
    }
  };
  containerElement
    .find(".plainTextInput")
    .keyup(onTextInput)
    .change(onTextInput)
    .on("paste", () => {
      setTimeout(() => {
        onTextInput();
      }, 0);
    });

  const onTitleEdit = () => {
    titleManuallyEdited = true;
  };
  containerElement
    .find('.addDocumentForm [name="title"]')
    .keyup(onTitleEdit)
    .change(onTitleEdit);

  fileUploadInput.change(() => {
    const file = fileUploadInput[0].files[0];
    const reader = new FileReader();

    if (file) {
      $('.addDocumentForm [name="title"]').val(
        file.name.replace(/\.txt$|\.epub(\.zip)?$/i, "")
      );
      containerElement.find(".addDocumentForm .whenReady").fadeIn();
      containerElement.find(".hideWhenReady").hide();
    }

    if (!file) {
      // TODO: this gets shown if the models.user clicks submit too quickly
      alert(
        "You need to select a file first.\n\n" +
          "Sometimes it takes a moment to read the file. " +
          "If you've already selected a " +
          "file, wait for the filename to appear " +
          'next to "Choose file" and try again.'
      );
    } else if (
      /audio\/(mpeg|mp3)/.test(file.type) ||
      /\.mp3$/i.test(file.name)
    ) {
      if (!models.user.hasPremiumAccess()) {
        accountModal.show({
          model: models.user,
          title: "audioUpload",
          messageHtml:
            "<h2>Upgrade To Upload Audio With Auto-Transcription</h2>",
          showTitle: false,
        });
        return;
      }

      const perFileLimit = 200; // MB
      if (file.size > perFileLimit * 1024 * 1024) {
        genericModals.alert({
          messageHtml: `Sorry, only audio files up to ${perFileLimit}Mb are supported.`,
        });
        return;
      }

      if (
        totalSecondsAudioUploaded > sharedConfig.audioUploadLimitPremiumPlus
      ) {
        genericModals.alert({
          messageHtml:
            `Sorry, you've reached your audio storage allowance of ${Math.floor(
              sharedConfig.audioUploadLimitPremiumPlus / 3600
            )} hours. If you need more, please get in touch with ` +
            `<a href="mailto:steve@readlang.com">steve@readlang.com</a>.`,
        });
        return;
      }

      if (
        !models.user.hasPremiumPlusAccess() &&
        totalSecondsAudioUploaded > sharedConfig.audioUploadLimitPremium
      ) {
        genericModals.alert({
          messageHtml: `Sorry, you've reached your audio storage allowance of ${Math.floor(
            sharedConfig.audioUploadLimitPremium / 3600
          )} hours. <a href="/account">Upgrade to Premium Plus</a> for ${Math.floor(
            sharedConfig.audioUploadLimitPremiumPlus / 3600
          )} hours of storage!`,
        });
        return;
      }

      fileUploadInput.attr("disabled", "disabled");
      uploadAudio(file);
    } else if (
      file.type === "application/epub+zip" ||
      /\.epub$/i.test(file.name) ||
      (file.type === "application/zip" && /\.epub\.zip$/i.test(file.name))
    ) {
      if (file.size > 3 * 1024 * 1024) {
        genericModals.alert({
          messageHtml:
            "Sorry, only epub files under 3Mb are supported. " +
            "I recommend using <a target='_blank' href='http://calibre-ebook.com/'>Calibre</a> to " +
            "convert your book to plain text before uploading.",
        });
        return;
      }
      reader.onload = async (event) => {
        if (await localAPI.isLocalMode()) {
          signupModal.show({
            headingHtml: "<h2>Sign in to import ePub books</h2>",
            models: models,
          });
        } else {
          ePub = event.target.result;
          containerElement
            .find(".addDocumentForm .left")
            .attr("disabled", "disabled");
          containerElement
            .find(".addDocumentForm .plainTextInput")
            .attr("disabled", "disabled");
          containerElement.find(".addDocumentForm .suggestion").hide();
          containerElement.find(".addDocumentForm .ePubInfo").fadeIn();
          containerElement
            .find(".addDocumentForm .ePubInfo .filename")
            .text(file.name);
          containerElement.find(".uploadEPub").fadeIn();
        }
      };
      reader.readAsBinaryString(file);
    } else {
      reader.onload = (event) => {
        inputTextArea.val(event.target.result);
        containerElement.find(".uploadPlainText").fadeIn();
      };
      reader.readAsText(file);
    }
  });

  const showUploadDialog = (type) => {
    let html = '<div class="centralDialog">';
    if (type === "epub") {
      html +=
        "<h3>" +
        "Uploading and converting ePub" +
        "</h3>" +
        "<p>Please wait, this may take a minute...</p>" +
        '<p style="text-align:center"><img src="/content/bigLoadingThrobber.gif"/></img></p>' +
        "<p><small>(If this doesn't work for you, please get in touch " +
        'with <a href="mailto:steve@readlang.com">steve@readlang.com</a>. ' +
        'Or <a href="http://calibre-ebook.com/">Use Calibre</a> to convert it to plain text first.' +
        ")</small></p>";
    } else {
      html +=
        "<h3>" +
        "Uploading plain text" +
        "</h3>" +
        "<p>Please wait, this may take a minute...</p>" +
        '<p style="text-align:center"><img src="/content/throbber.gif"/></img></p>';
    }
    html += "</div>";

    modalDialog.show($(html), {
      clickToCancel: false,
      closeButton: false,
    });
  };

  containerElement.find(".uploadEPub").click(async () => {
    if (await localAPI.isLocalMode()) {
      signupModal.show({
        headingHtml: "<h2>Sign in to upload books</h2>",
        models: models,
      });
      return;
    }

    showUploadDialog("epub");
    upload({
      title: $('.addDocumentForm [name="title"]').val(),
      author: $('.addDocumentForm [name="author"]').val(),
      category: selectedCategory(),
      ePub: ePub,
      language: models.user.get("currentLearningLanguage"),
      useEveryNewLine: true,
      public: containerElement
        .find('.addDocumentForm [name="public"]')
        .is(":checked"),
      aiGenerated: containerElement
        .find('.addDocumentForm [name="aiGenerated"]')
        .is(":checked"),
      source: "uploadEpub",
    });
  });

  containerElement.find(".uploadPlainText").click(async () => {
    if (await localAPI.isLocalMode()) {
      signupModal.show({
        headingHtml: "<h2>Sign in to upload texts</h2>",
        models: models,
      });
      return;
    }

    const uploadData = {
      title: $('.addDocumentForm [name="title"]').val().toString(),
      author: $('.addDocumentForm [name="author"]').val().toString(),
      category: selectedCategory(),
      body: inputTextArea.val(),
      language: models.user.get("currentLearningLanguage"),
      useEveryNewLine: true,
      public: containerElement
        .find('.addDocumentForm [name="public"]')
        .is(":checked"),
      aiGenerated: containerElement
        .find('.addDocumentForm [name="aiGenerated"]')
        .is(":checked"),
      source: "uploadText",
    };

    if (!uploadData.body || uploadData.body.length === 0) {
      alert("Paste or type text to upload first");
      return;
    }

    if (!uploadData.title || uploadData.title.length === 0) {
      alert("Enter a title first");
      return;
    }

    if (inputTextArea.val().length > 50000) {
      showUploadDialog("txt");
    }
    upload(uploadData);
  });

  renderedCallback();
};

var selectedCategory = () =>
  $('.categorySelect option:not(".dummyOption"):selected').text();

var upload = (data) => {
  readlangClient.request(
    "POST",
    "/api/book",
    data,
    (responseData) => {
      if (responseData.success) {
        modalDialog.cancel();
        appRouter.navigate(
          "/myTexts/queue", // + data.bookID,
          { trigger: true }
        );

        walkthrough.setAchievement("uploadText");
      } else {
        $("#uploadDialog #uploadPlainText")
          .removeAttr("disabled")
          .text("Submit Document");
        $("#uploadDialog .throbber").hide();
        if (responseData.error) {
          alert(responseData.error);
        } else {
          alert("error: " + JSON.stringify(responseData));
        }
      }
    },
    (error) => {
      modalDialog.cancel();
      if (error.status === 413) {
        alert(
          "Readlang only supports uploading files up to 3MB in size, sorry!"
        );
      } else {
        if (error.responseJSON && error.responseJSON.epubConvertError) {
          alert(
            "Something went wrong converting your ePub file. " +
              "Please try uploading a plain text version instead."
          );
        } else {
          alert(
            error.status + " error uploading file: " + JSON.stringify(error)
          );
        }
      }
    }
  );
};

const uploadAudio = (file) => {
  const formData = new FormData();
  formData.append("audio", file);
  formData.append("language", models.user.get("currentLearningLanguage"));
  formData.append("quality", "medium");

  const showProgress = (fractionComplete: number) => {
    containerElement.html(
      `<p>Uploading audio file... ${Math.round(fractionComplete * 100)}%</p>`
    );
  };
  showProgress(0);

  const xhr = new XMLHttpRequest();

  xhr.open("POST", "/api/audio", true);

  xhr.onload = () => {
    if (xhr.status === 200) {
      appRouter.navigate("/audioUploaded", { trigger: true });
    } else {
      let errorMessage = undefined;
      if (xhr.status === 413) {
        errorMessage = "Sorry, this file is too large.";
      } else if (xhr.status === 429) {
        errorMessage =
          "Sorry, the audio upload queue is currently full, please try again later.";
      } else {
        errorMessage = "Error uploading audio file: " + xhr.statusText;
      }

      if (errorMessage) {
        containerElement.html(
          `<div>
          <p>${errorMessage}</p>
          <p><a href="#" id="return">Return to upload</a></p>
          </div>`
        );
        containerElement.find("#return").click(() => {
          window.location.href = "/upload";
        });
      }
    }
  };

  // Just output to console for now
  xhr.upload.onprogress = (event) => {
    if (event.lengthComputable) {
      showProgress(event.loaded / event.total);
    }
  };

  xhr.send(formData);
};

export const showHeader = true;
